// @ts-nocheck
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';
import { DocumentTemplateService } from './documentTemplateService';

const DOCUMENT_TEMPLATE = 'documentTemplate';

export const DOCUMENT_TEMPLATE_QUERY_KEYS = {
  ALL: [DOCUMENT_TEMPLATE],
  documentTemplateList: {
    ROOT: [DOCUMENT_TEMPLATE, 'documentTemplateList'],
    key: (params = EMPTY_OBJECT) => [
      DOCUMENT_TEMPLATE,
      'documentTemplateList',
      params,
    ],
  },
  sharableLink: {
    ROOT: [DOCUMENT_TEMPLATE, 'sharableLink'],
    key: (params = EMPTY_OBJECT) => [DOCUMENT_TEMPLATE, 'sharableLink', params],
  },
};

export const useDocumentTemplateListQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    DOCUMENT_TEMPLATE_QUERY_KEYS.documentTemplateList.key,
    DocumentTemplateService.getDocumentTemplates,
    params,
    options
  );
};

export const useUploadDocumentTemplateMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentTemplateService.uploadDocumentTemplate, {
    ...options,
    invalidateQueries: [DOCUMENT_TEMPLATE_QUERY_KEYS.documentTemplateList.ROOT],
  });
};

export const useDeleteDocumentTemplateMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentTemplateService.deleteDocumentTemplate, {
    ...options,

    invalidateQueries: [DOCUMENT_TEMPLATE_QUERY_KEYS.documentTemplateList.ROOT],
  });
};

export const useDownloadTemplateDocumentMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(
    (params) =>
      DocumentTemplateService.downloadTemplateDocument(params, {
        loader: false,
      }),

    options
  );
};

export const useCreateDocumentMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentTemplateService.createDocument, {
    ...options,
    invalidateQueries: [DOCUMENT_TEMPLATE_QUERY_KEYS.documentTemplateList.ROOT],
  });
};

export const useFetchSharableLinkQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    DOCUMENT_TEMPLATE_QUERY_KEYS.sharableLink.key,
    DocumentTemplateService.fetchSharableLink,
    params,
    options
  );
};
